"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = _default;
exports.POST_ACTIVITY = exports.POST_ACTIVITY_REJECTED = exports.POST_ACTIVITY_PENDING = exports.POST_ACTIVITY_FULFILLED = void 0;

var _reduxPromiseMiddleware = require("redux-promise-middleware");

var POST_ACTIVITY = 'DIRECT_LINE/POST_ACTIVITY';
exports.POST_ACTIVITY = POST_ACTIVITY;
var POST_ACTIVITY_FULFILLED = "".concat(POST_ACTIVITY, "_").concat(_reduxPromiseMiddleware.FULFILLED);
exports.POST_ACTIVITY_FULFILLED = POST_ACTIVITY_FULFILLED;
var POST_ACTIVITY_PENDING = "".concat(POST_ACTIVITY, "_").concat(_reduxPromiseMiddleware.PENDING);
exports.POST_ACTIVITY_PENDING = POST_ACTIVITY_PENDING;
var POST_ACTIVITY_REJECTED = "".concat(POST_ACTIVITY, "_").concat(_reduxPromiseMiddleware.REJECTED);
exports.POST_ACTIVITY_REJECTED = POST_ACTIVITY_REJECTED;

function _default(activity) {
  var method = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'keyboard';
  return {
    type: POST_ACTIVITY,
    meta: {
      method: method
    },
    payload: {
      activity: activity
    }
  };
}